import axios from 'axios';
import { makeAutoObservable } from 'mobx';
import { Notification } from '../../config/Global';
import Message from '../../config/Message';

export default class RootStore {
	login_redirect_timer;
	isUnauthorise = false;

	constructor() {
		makeAutoObservable(this);
		this.setAxiosBaseUrl();
		if (localStorage.getItem('token')) {
			this.setAxiosHeaders(localStorage.getItem('token'));
		}
	}

	setAxiosBaseUrl = () => {
		axios.defaults.baseURL = process.env.REACT_APP_API_URL || '';
	};

	setAxiosInterceptor = () => {
		axios.interceptors.request.use(
			(config) => {
				let header = config.headers;
				const authToken = localStorage.getItem('token');
				header = {
					...header,
					Accept: 'application/json',
				};
				if (authToken) {
					header.Authorization = 'Bearer ' + authToken;
				}
				config.headers = header;
				/** In dev, intercepts request and logs it into console for dev */
				return config;
			},
			(error) => {
				// Handle request error
				return Promise.reject(error);
			}
		);
		axios.interceptors.response.use(
			(response) => {
				if (
					response?.data?.NOTIFICATION &&
					response?.data?.NOTIFICATION[0]
				) {
					Notification.success({
						message: response.data.NOTIFICATION,
					});
				}
				return response;
			},
			(e) => {
				if (e.response) {
					if (e.response.status !== 422) {
						if (e.response?.data?.title) {
							Notification.error({
								message:
									e.response?.data?.title ||
									e.response?.data?.message,
							});
						}
					}
					if (e.response.status === 401) {
						this.setIsUnauthorise(true);
						this.resetStore();
						window.location.replace('/');
					}
					return Promise.reject(e.response);
				} else {
					Notification.error({
						message: Message().global.networkIssue,
					});
					return Promise.reject({
						data: [],
						message: Message().global.networkIssue,
					});
				}
			}
		);
	};

	setIsUnauthorise = (value) => {
		this.isUnauthorise = value;
	};

	resetStore = () => {
		localStorage.clear();
	};

	setAxiosHeaders = (access_token) => {
		if (access_token) localStorage.setItem('token', access_token);
		const auth_token = localStorage.getItem('token');
		if (auth_token && auth_token !== 'undefined') {
			return Promise.resolve(auth_token);
		} else {
			return Promise.reject();
		}
	};

	assignErrorToInput = (form, errors) => {
		const formattedErrors = [];
		if (errors) {
			Object.keys(errors).forEach((key) => {
				formattedErrors.push({
					name: key,
					errors: errors[key],
				});
			});
			formattedErrors.forEach((x) => {
				if (typeof x.name === 'string' && x.name.indexOf('.') !== -1) {
					const name = x.name.split('.');
					name.forEach((e) => {
						if (!isNaN(parseInt(e))) {
							e = parseInt(e);
						}
					});
				}
			});
		}
		form.setFields(formattedErrors);
	};

	getServerListPayload = (params, searchText) => {
		let sortColumnName = `${params.request.sortModel[0].colId} ${params.request.sortModel[0].sort}`;
		return {
			sortBy: sortColumnName,
			isActive: 1,
			searchValue: searchText,
			pageSize:
				(params.request.endRow ?? 0) - (params.request.startRow ?? 0),
			pageNo: Math.ceil(
				((params.request.startRow ?? 0) + 1) /
					((params.request.endRow ?? 0) -
						(params.request.startRow ?? 0))
			),
		};
	};
}
